import { observable, action } from "mobx";
import { post } from "../services/ajax.service";

class BobSavingsStore {

  @observable total_participant_count = 0;
  @observable total_employees_count = 0;
  @observable total_claims = 0;
  @observable total_spend = 0;
  @observable total_savings = 0;
  @observable current_pmpm = 0;
  @observable previous_six_month_savings = 0;
  @observable recent_twelve_month_savings = 0;
  @observable inception_savings = 0;
  @observable physician_denied = 0;
  @observable physician_approved = 0;
  @observable engagement_approved_physicians = 0;
  @observable engagement_denied_physicians = 0;
  @observable participant_approved = 0;
  @observable participant_denied = 0;
  @observable in_progress = 0;
  @observable participant_communications = 0;
  @observable therapeutic_class_breakdown = [];
  @observable savings_summary_by_drugs_type = [];
  @observable monthly_plan_spend = [];
  @observable cost_containment_savings = [];
  @observable user_all_groups = [];
  @observable physicians_engagement = [];
  @observable action = false;
  @observable recent = false;
  @observable errors = {};
  @observable url = "/api/v1/bobSavingsActions";



  @action setErrors = () => {
    this.errors = {};
  };
  @action setAction = action => {
    this.action = action;
  };


  @action getAllUserGroups = async data => {
    this.user_all_groups = [];
    try {
      let response = await post(
        `${this.url}/getAllUserGroups`,
        data
      );

      this.user_all_groups = response.data;
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getTotalParticipants = async data => {
    const response = await post(
      `${this.url}/getTotalParticipants`, data
    );
    this.total_participant_count = response.data;
  }

  @action getTotalEmployees = async data => {
    const response = await post(
      `${this.url}/getTotalEmployees`, data
    );
    this.total_employees_count = response.data[0]?.employee_count;
  }
  @action getTotalClaims = async data => {
    const response = await post(
      `${this.url}/getTotalClaims`, data
    );
    this.total_claims = response.data[0]?.total_claims_of_group;
  }
  @action getTotalSpend = async data => {
    const response = await post(
      `${this.url}/getTotalSpend`, data
    );
    this.total_spend = response.data[0]?.total_spend;
  }
  @action getTotalSavings = async data => {
    const response = await post(
      `${this.url}/getTotalSavings`, data
    );
    this.total_savings = response.data[0]?.Total_Savings;
  }
  @action getPMPM = async data => {
    const response = await post(
      `${this.url}/getPMPM`, data
    );
    this.current_pmpm = response.data[0]?.PMPM;
  }
  @action getSavingsSummaryByDrugsType = async data => {
    const response = await post(
      `${this.url}/getSavingsSummaryByDrugsType`, data
    );
    this.savings_summary_by_drugs_type = response.data;
  }

  @action getMonthlyPlanSpend = async data => {
    const response = await post(
      `${this.url}/getMonthlyPlanSpend`, data
    );
    this.monthly_plan_spend = response.data;
    this.recent = response?.data[0]?.recent ?? false;
  }
  @action getCostContainmentSavings = async data => {
    const response = await post(
      `${this.url}/getCostContainmentSavings`, data
    );
    this.cost_containment_savings = response.data;
  }
  @action getPreviousSixMonthSavings = async data => {
    const response = await post(
      `${this.url}/getPreviousSixMonthSavings`, data
    );
    this.previous_six_month_savings = response.data[0]?.previous_6_month_savings;
  }
  @action getRecentTwelveMonthSavings = async data => {
    const response = await post(
      `${this.url}/getRecentTwelveMonthSavings`, data
    );
    this.recent_twelve_month_savings = response.data[0]?.recent_12_month_savings;
  }
  @action getInceptionSavings = async data => {
    const response = await post(
      `${this.url}/getInceptionSavings`, data
    );
    this.inception_savings = response.data[0]?.inception_savings;
  }

  @action getPhysicianDenied = async data => {
    const response = await post(
      `${this.url}/getPhysicianDenied`, data
    );
    this.physician_denied = response.data[0]?.count;
  }
  @action getPhysicianApproved = async data => {
    const response = await post(
      `${this.url}/getPhysicianApproved`, data
    );
    this.physician_approved = response.data[0]?.count;
  }
  @action getParticipantDenied = async data => {
    const response = await post(
      `${this.url}/getParticipantDenied`, data
    );
    this.participant_denied = response.data[0]?.count;
  }
  @action getParticipantApproved = async data => {
    const response = await post(
      `${this.url}/getParticipantApproved`, data
    );
    this.participant_approved = response.data[0]?.count;
  }
  @action getInProgress = async data => {
    const response = await post(
      `${this.url}/getInProgress`, data
    );
    this.in_progress = response.data[0]?.count;
  }
  @action getParticipantCommunications = async data => {
    const response = await post(
      `${this.url}/getParticipantCommunications`, data
    );
    this.participant_communications = response.data[0]?.communication_count;
  }
  @action getApprovedPhysiciansEngagement = async data => {
    const response = await post(
      `${this.url}/getApprovedPhysiciansEngagement`, data
    );
    this.engagement_approved_physicians = response.data[0];
  }
  @action getDeniedPhysiciansEngagement = async data => {
    const response = await post(
      `${this.url}/getDeniedPhysiciansEngagement`, data
    );
    this.engagement_denied_physicians = response.data[0];
  }

  @action getPhysiciansEngagement = async data => {
    const response = await post(
      `${this.url}/getPhysiciansEngagement`, data
    );
    this.physicians_engagement = response.data;
  }

  @action getTherapeuticClassBreakDownAndSavings = async data => {
    this.therapeutic_class_breakdown = [];
    try {
      let response = await post(
        `${this.url}/getTherapeuticClassBreakDownAndSavings`,
        data
      );
      this.therapeutic_class_breakdown = response.data;
    } catch (err) {
      console.log(err);
    }
  };


}

export default BobSavingsStore;
